import type React from 'react';
import { useTranslation } from 'react-i18next';
import { EWebclientSnippet } from '../../../../constants/EWebclientSnippet';
import { useWebclientSnippet } from '../../../../hooks/settings/webclients/useWebclientSnippet';
import MaterialIcon from '../../../common/MaterialIcon';

export const WebclientSnippetModal: React.FC = () => {
  const {
    copySnippetToClipboard,
    snippetContent,
    snippetType,
    setSnippetType,
  } = useWebclientSnippet();
  const { t } = useTranslation();

  return (
    <div className='tailwind-modal-body flex flex-col'>
      <p className='text-base italic mb-3'>
        {t('settings.webclient.snippet.description')}
      </p>
      <div className='flex justify-between mb-2 mt-2'>
        <div className='flex flex-wrap gap-y-1'>
          {Object.values(EWebclientSnippet).map(
            (snippet: string, index: number) => {
              const isSelected = snippetType === snippet;
              return (
                <button
                  type='button'
                  id={`tbg-btn-${index + 1}`}
                  key={snippet}
                  className={`px-3 py-2 text-gray-500 text-sm font-normal flex-auto border-r max-w-[105px] ${
                    isSelected ? 'bg-success text-white' : 'bg-gray-200'
                  } ${
                    index < Object.values(EWebclientSnippet).length - 1
                      ? 'border-r border-gray-200'
                      : ''
                  }`}
                  onClick={() => setSnippetType(snippet as EWebclientSnippet)}>
                  {t(`settings.webclient.snippet.${snippet.toLowerCase()}`)}
                </button>
              );
            },
          )}
        </div>
        <div className='flex flex-row items-center'>
          <MaterialIcon
            icon={'content_copy'}
            onClick={copySnippetToClipboard}
          />
          <div className='cursor-pointer' onClick={copySnippetToClipboard}>
            {t('general.buttons.copy')}
          </div>
        </div>
      </div>
      <pre className='w-full px-3 bg-light-base overflow-auto'>
        {snippetContent?.trim() || ''}
      </pre>
    </div>
  );
};

export default WebclientSnippetModal;
